import { render, staticRenderFns } from "./LoginRelationDetails.vue?vue&type=template&id=4f6cde7e"
import script from "./LoginRelationDetails.vue?vue&type=script&lang=js"
export * from "./LoginRelationDetails.vue?vue&type=script&lang=js"
import style0 from "./LoginRelationDetails.vue?vue&type=style&index=0&id=4f6cde7e&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports